<div class="not-found">
  <div class="big-text">404</div>
  <h1>Sorry, the page you're trying to access is unavailable.</h1>
  <app-searchbar></app-searchbar>
  <br />
</div>
